<template>
  <v-row>
    <v-col cols="12">
      <v-select
        v-model="templateWhatsAppSelecionadoIdLocale"
        dense
        outlined
        validate-on-blur
        label="Templates de WhatsApp"
        placeholder="Templates de WhatsApp"
        no-data-text="Nenhum template de WhatsApp disponível"
        item-value="id"
        item-text="nome"
        :readonly="readonly"
        :filled="readonly"
        :loading="loading"
        :items=" templatesWhatsApp"
        @change="v => $emit('update:templateWhatsAppSelecionadoId', v)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import CanalService from '@/services/modules/CanalService'

export default {
  emits: ['update:templateWhatsAppSelecionadoId'],

  props: {
    canalId: {
      type: Number,
      required: true,
    },
    templateWhatsAppSelecionadoId: {
      type: Number,
      default: null,
    },
    readonly: Boolean,
  },

  setup(props) {
    const templatesWhatsApp = ref([])
    const templateWhatsAppSelecionadoIdLocale = ref(null)
    const loading = ref(false)

    watch(
      () => props.templateWhatsAppSelecionadoId,
      v => {
        if (!v) return
        templateWhatsAppSelecionadoIdLocale.value = v
      },
      {
        immediate: true,
      },
    )

    async function getTemplatesWhatsApp(canalId) {
      if (loading.value) return
      if (!canalId) return

      try {
        loading.value = true
        templatesWhatsApp.value = await CanalService.getTemplatesWhatsApp(canalId)
      } finally {
        loading.value = false
      }
    }

    watch(() => props.canalId, getTemplatesWhatsApp, { immediate: true })

    return {
      templatesWhatsApp,
      templateWhatsAppSelecionadoIdLocale,
      loading,
    }
  },
}
</script>
